"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Auth_1 = require("../../actions/Auth");
exports.default = (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch('/verifyAuthentication', { credentials: 'include' });
        if (response.status === 200) {
            // authorized (user authentication succeeded)
            const body = yield response.json();
            if (body.user) {
                dispatch((0, Auth_1.login)(body.user, true));
            }
            else {
                dispatch((0, Auth_1.logout)());
            }
        }
        else if (response.status === 401) {
            dispatch((0, Auth_1.logout)());
        }
    }
    catch (err) {
        console.log('Error verifying authentication.', err);
    }
});
//# sourceMappingURL=verifyAuthentication.js.map